import { __rest } from "tslib";
export function flattenTreeDataClosure(treeData) {
    const flattenData = [];
    function flattenTree(data, __parentKey) {
        data === null || data === void 0 ? void 0 : data.forEach((ele) => {
            const { key, children } = ele, other = __rest(ele, ["key", "children"]);
            flattenData.push(Object.assign({}, Object.assign(Object.assign({}, other), { key, __parentKey, children })));
            if (children) {
                flattenTree(children, key);
            }
        });
    }
    flattenTree(treeData, null);
    return flattenData;
}
export function findParent(key, flattenTree) {
    const parentArr = []; // 存储所有的父级元素
    function find(key, flattenTree) {
        if (!key)
            return;
        flattenTree === null || flattenTree === void 0 ? void 0 : flattenTree.forEach((ele) => {
            if (ele.key === key) {
                parentArr.unshift(ele);
                find(ele.__parentKey, flattenTree);
            }
        });
    }
    find(key, flattenTree);
    return parentArr;
}
// export function filterSubPageNode(nodes: any[], key: any, childFlag: boolean) {
//   const newNodes = nodes
//     ?.map((item) => {
//       if (item?.data?.type === 'subpage' && (item.key !== key || childFlag)) {
//         return;
//       }
//       if (item.children) {
//         item.children = filterSubPageNode(item.children, key, true);
//       }
//       return item;
//     })
//     .filter((item) => item);
//   return newNodes;
// }
export function getParentNoSubPageKey(key, flattenData) {
    function findParent(_key) {
        var _a, _b;
        for (let i = 0; i < flattenData.length; i++) {
            if (flattenData[i].key === _key) {
                return ((_b = (_a = flattenData[i]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type) === 'subpage'
                    ? findParent(flattenData[i].__parentKey)
                    : _key;
            }
        }
    }
    return findParent(key);
}
/**
 * 根据 key 获取节点数据
 * @param key
 * @param data
 */
export function getNavigationByKey(key, data) {
    const allData = flattenTreeDataClosure(data);
    const item = allData.filter((item) => item.key === key);
    return item[0];
}
